import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['header', 'content', 'element', 'subElement'];

	openContent() {
		this.headerTarget.classList.add('hidden');
		this.contentTarget.classList.remove('hidden');
	}

	toggleContent() {
		if (this.elementTarget.hasAttribute('data-group-active')) {
			this.elementTarget.removeAttribute('data-group-active');
		} else {
			this.elementTarget.setAttribute('data-group-active', true);
		}
	}

	toggleSubContent() {
		if (this.subElementTarget.hasAttribute('data-group-active-sub')) {
			this.subElementTarget.removeAttribute('data-group-active-sub');
		} else {
			this.subElementTarget.setAttribute('data-group-active-sub', true);
		}
	}
}
